// extracted by mini-css-extract-plugin
export default {"basketWithObject":"BasketManager_basketWithObject__2zwSw","removeButton":"BasketManager_removeButton__Q0kE3","existingBaskets":"BasketManager_existingBaskets__Tc-vd"};